import React, {useEffect, useRef} from 'react';
import {KTSVG} from "../../../../../_metronic/helpers";
import {ClientAdresseForm} from "./ClientAdresseForm";
import {ModeleClientAdresse, modeleClientAdresseInitValues} from "../../../../../components/Models";
import {createClientAdresse, editClientAdresse} from "../../../../../components/requests";

interface ClientAdresseFormModalProps {
  clientId?: any
  clientAdresses?: any
  setClientAdresses?: any
  clientAdresseEdit?: any
  setRefetchClientData?: any
  isFromFicheClient?: any
  setClientAdresseData?: any
}

function ClientAdresseFormModal(
  {
    clientId,
    clientAdresses,
    setClientAdresses,
    clientAdresseEdit = null,
    setRefetchClientData,
    isFromFicheClient = false,
    setClientAdresseData
  }: ClientAdresseFormModalProps) {
  const btnCloseRef = useRef<any>(null)

  const submitForm = async (fieldsToUpdate: Partial<ModeleClientAdresse>, callback): Promise<void> => {
    const updatedData = Object.assign({...modeleClientAdresseInitValues}, fieldsToUpdate)
    let result
    try {
      const clientAdresseRequest = !clientAdresseEdit
        ? await createClientAdresse(clientId, updatedData)
        : await editClientAdresse(clientId, clientAdresseEdit?.id, updatedData);
      if (clientAdresseRequest?.status === 200 && clientAdresseRequest?.data?.id !== undefined && clientAdresseRequest?.data?.id !== null) {
        const updatedData = (!clientAdresseEdit) ? [
          ...clientAdresses,
          clientAdresseRequest?.data
        ] : clientAdresses.map(
          (item) =>
            item?.id === clientAdresseRequest?.data?.id
              ? clientAdresseRequest?.data
              : item
        )
        setClientAdresses(updatedData)
        result = clientAdresseRequest?.data
        btnCloseRef.current.click()
      }
    } catch (ex) {
      console.error(ex)
    } finally {
      callback(result)
    }
  }

  return (
    <div
      className='modal fade'
      id='modalAddAddress'
      aria-hidden='true'
      aria-labelledby='modalToggleLabelAddAddress'
      tabIndex={-1}
    >
      <div className='modal-dialog modal-xl'>
        <div className='modal-content'>
          <div className='modal-header'>
            <h5 className='modal-title' id='modalToggleLabelAddAddress'>
              {!clientAdresseEdit ? 'Créer' : 'Modifier'} une adresse
            </h5>
            <div
              className='btn btn-icon btn-sm btn-active-light-primary ms-2'
              data-bs-target={isFromFicheClient ? '#modal_client_show_page' : undefined}
              data-bs-toggle={isFromFicheClient ? 'modal' : undefined}
              data-bs-dismiss={isFromFicheClient ? undefined : 'modal'}
              aria-label={isFromFicheClient ? undefined : 'Close'}
              ref={btnCloseRef}
            >
              <KTSVG
                path='/media/icons/duotune/arrows/arr061.svg'
                className='svg-icon svg-icon-2x'
              />
            </div>
          </div>
          <ClientAdresseForm
            clientId={clientId}
            adresseId={null}
            data={clientAdresseEdit}
            submitForm={submitForm}
            setRefetchClientData={setRefetchClientData}
            setClientAdresseData={setClientAdresseData}
          />
        </div>
      </div>
    </div>
  );
}

export default ClientAdresseFormModal;